<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-custom">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">Generate Official e-Receipt</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-5">
              <div>
                <b-form-group label="Branch" label-for="businessprofileid">
                  <b-form-select
                    v-model="$v.form.BusinessProfileId.$model"
                    :options="profiles"
                    :state="validateState('BusinessProfileId')"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="businessprofileid"
                    placeholder="Revenue District Office"
                    size="sm"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    Branch is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    label="Date"
                    label-for="Date"
                  >
                  <b-input-group>
                    <b-form-input
                      v-model="$v.form.TransactionDateTime.$model"
                      :state="validateState('TransactionDateTime')"
                      name="Date"
                      type="text"
                      autocomplete="off"
                      v-mask="'####-##-##'"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      placeholder="YYYY-MM-DD"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="$v.form.TransactionDateTime.$model"
                        :state="validateState('TransactionDateTime')"
                        class="button-only-datepicker"
                        name="Date"
                        size="sm"
                        button-only
                        right
                        locale="en-US"
                      ></b-form-datepicker>
                    </b-input-group-append>
                    <b-form-invalid-feedback>
                      Transaction Date is required.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
                <b-form-group label="Sold To" label-for="SoldTo">
                  <b-form-input
                    v-model="$v.form.Buyer.Name.$model"
                    :state="validateState('Name', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="SoldTo"
                    placeholder="Sold To"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Sold To is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Address" label-for="Address">
                  <b-form-textarea
                    v-model="$v.form.Buyer.Address.$model"
                    :state="validateState('Address', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    max-rows="8"
                    name="Address"
                    placeholder="Address"
                    rows="5"
                    size="sm"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>
                    Address is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Buyer's TIN" label-for="TIN">
                  <b-form-input
                    v-model="$v.form.Buyer.TIN.$model"
                    v-mask="'###-###-###'"
                    :state="validateState('TIN', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="TIN"
                    placeholder="Buyer's TIN"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Buyer's TIN is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Buyer's Branch Code" label-for="BranchCode">
                  <b-form-input
                    v-model="$v.form.Buyer.BranchCode.$model"
                    v-mask="'#####'"
                    :state="validateState('BranchCode', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="BranchCode"
                    placeholder="Buyer's Branch Code"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Buyer's Branch Code is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Buyer's Business Style" label-for="BusinessStyle">
                  <b-form-input
                    v-model="$v.form.Buyer.BusinessStyle.$model"
                    :state="validateState('BusinessStyle', this.$v.form.Buyer)"
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="BusinessStyle"
                    placeholder="Buyer's Business Style"
                    size="sm"
                  ></b-form-input>
                  <!-- <b-form-invalid-feedback>
                    Buyer's Branch Code is required.
                  </b-form-invalid-feedback> -->
                </b-form-group>
              </div>
              <div>
                <h6>Discount</h6>
                <b-form-group label="Discount Type">
                  <b-form-radio-group
                    v-model="$v.form.DiscountType.$model"
                    :options="options.DiscountType"
                    :state="validateState('DiscountType', this.$v.form)"
                    name="radio-options-DiscountType"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback>
                    Discount Type is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-if="showSeniorDiscount || showPwdDiscount" label="Rate">
                  <b-form-select
                    v-model="$v.form.Rate.$model"
                    :options="options.Rate"
                    :state="validateState('Rate', this.$v.form)"
                    name="radio-options-Rate"
                  ></b-form-select>
                  <b-form-invalid-feedback>
                    Rate is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-if="showStoreOtherDiscount" label="Rate">
                    <b-form-input
                      v-model="$v.form.Rate.$model"
                      type="number"
                      min="0"
                      v-mask="'###'"
                      :state="validateState('Rate', this.$v.form)"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="Rate"
                      placeholder="Rate"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Rate is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
              </div>
              <div>
                <!-- <button
                  class="text-muted d-block"
                  type="button"
                  @click="addSeniorCitizenDiscount"
                >
                  <i class="flaticon2-add-square"></i> Add Senior Citizen
                  Discount
                </button> -->
                <div v-show="showSeniorDiscount">
                  <!-- <h5>Senior Citizen Discount</h5> -->
                  <b-form-group
                    label="OSCA Id Number"
                    label-for="SeniorCitizenOSCAIdNumber"
                  >
                    <b-form-input
                      v-model="$v.form.SeniorCitizen.OSCAIdNumber.$model"
                      :state="
                        validateState(
                          'OSCAIdNumber',
                          this.$v.form.SeniorCitizen
                        )
                      "
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="SeniorCitizenOSCAIdNumber"
                      placeholder="OSCA Id Number"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      OSCAIdNumber is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                    label="Senior Citizen Name"
                    label-for="SeniorCitizenName"
                  >
                    <b-form-input
                      v-model="$v.form.SeniorCitizen.Name.$model"
                      :state="validateState('Name', this.$v.form.SeniorCitizen)"
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="SeniorCitizenName"
                      placeholder="Name"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Senior Citizen Name is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- <b-form-group
                    label="Discount Total"
                    label-for="SeniorCitizenDiscountTotal"
                  >
                    <b-form-input
                      v-model="$v.form.SeniorCitizen.DiscountTotal.$model"
                      type="number"
                      :state="
                        validateState(
                          'DiscountTotal',
                          this.$v.form.SeniorCitizen
                        )
                      "
                      class="form-control form-control-solid h-auto py-3 px-3 w-100"
                      name="SeniorCitizenDiscountTotal"
                      placeholder="Discount Total"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Senior Citizen Discount Total is required.
                    </b-form-invalid-feedback>
                  </b-form-group> -->
                </div>
              </div>
              <div>
                <!-- <button
                  class="text-muted d-block"
                  type="button"
                  @click="addPwdDiscount"
                >
                  <i class="flaticon2-add-square"></i> Add PWD Discount
                </button> -->
                <div v-show="showPwdDiscount">
                  <!-- <h5>Person With Disability Discount</h5> -->
                  <b-form-group label="PWD Id Number" label-for="PWDIdNumber">
                    <b-form-input
                      v-model="$v.form.PersonWithDisability.PwdIdNumber.$model"
                      :state="
                        validateState(
                          'PwdIdNumber',
                          this.$v.form.PersonWithDisability
                        )
                      "
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="PwdIdNumber"
                      placeholder="PWD Id Number"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      PWD ID Number is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="PWD Name" label-for="PWDName">
                    <b-form-input
                      v-model="$v.form.PersonWithDisability.Name.$model"
                      :state="
                        validateState('Name', this.$v.form.PersonWithDisability)
                      "
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="PWDName"
                      placeholder="Name"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      PWD Name is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <!-- <b-form-group
                    label="PWD Discount Total"
                    label-for="PWDDiscountTotal"
                  >
                    <b-form-input
                      v-model="
                        $v.form.PersonWithDisability.DiscountTotal.$model
                      "
                      type="number"
                      :state="
                        validateState(
                          'DiscountTotal',
                          this.$v.form.PersonWithDisability
                        )
                      "
                      class="form-control form-control-solid h-auto py-3 px-3 w-100"
                      name="PWDDiscountTotal"
                      placeholder="Discount Total"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      PWD Discount Total is required.
                    </b-form-invalid-feedback>
                  </b-form-group> -->
                </div>
              </div>
              <div>
                <div v-show="showNaacDiscount">
                  <!-- <h5>Person With Disability Discount</h5> -->
                  <b-form-group label="NAAC ID Number" label-for="IDNumber">
                    <b-form-input
                      v-model="$v.form.NAAC.IDNumber.$model"
                      :state="
                        validateState(
                          'IDNumber',
                          this.$v.form.NAAC
                        )
                      "
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="IDNumber"
                      placeholder="NAAC ID Number"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      NAAC ID Number is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group label="Name" label-for="Name">
                    <b-form-input
                      v-model="$v.form.NAAC.Name.$model"
                      :state="
                        validateState('Name', this.$v.form.NAAC)
                      "
                      class="form-control form-control-solid h-auto py-3 px-3"
                      name="Name"
                      placeholder="Athlete/Coach Name"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      Athlete/Coach Name is required.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <b-form-group
                label="Nature of Service"
                label-for="NatureOfService"
              >
                <b-form-input
                  v-model="$v.form.NatureOfService.$model"
                  :state="
                    validateState('NatureOfService', this.$v.form)
                  "
                  class="form-control form-control-solid h-auto py-3 px-3 w-100"
                  name="NatureOfService"
                  placeholder="Nature of Service"
                  size="sm"
                ></b-form-input>
                <b-form-invalid-feedback>
                  Nature of Service is required.
                </b-form-invalid-feedback>
              </b-form-group>
              <h5>In Settlement Of</h5>
              <div class="table-responsive">
                <table
                  class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover"
                >
                  <thead>
                    <tr class="text-uppercase">
                      <th style="width: 150px">SB No./Item</th>
                      <th style="width: 80px">Qty</th>
                      <th style="width: 80px">Unit</th>
                      <th style="width: 80px">Price</th>
                      <th v-if="globalTaxtType == 'Vatable'" style="width: 80px">Type</th>
                      <th style="width: 20px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in form.Items" :key="item.Description">
                      <td style="width: 150px">
                        <span class="text-muted d-block">{{
                          item.Description
                        }}</span>
                      </td>
                      <td style="width: 80px">
                        <span class="text-muted d-block">{{ item.Quantity }}</span>
                      </td>
                      <td style="width: 80px">
                        <span class="text-muted d-block">{{ item.Unit }}</span>
                      </td>
                      <td style="width: 80px">
                        <span class="text-muted d-block">{{ item.Price }}</span>
                      </td>
                      <td v-if="globalTaxtType == 'Vatable'" style="width: 80px">
                        <span class="text-muted d-block">{{ item.TaxType }}</span>
                      </td>
                      <td>
                        <button
                          :ref="'deleteItem_' + item.ProviderServiceId"
                          :disabled="isBusy"
                          class="text-muted d-block"
                          type="button"
                          @click="confirmDeleteItem(item)"
                        >
                          <i class="flaticon-delete"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b-form-input
                          v-model="newItem.Description"
                          class="form-control"
                          placeholder="SB No./Item"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="newItem.Quantity"
                          class="form-control"
                          placeholder="Qty"
                          v-on:change="computeSalesTotal"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="newItem.Unit"
                          class="form-control"
                          placeholder="Unit"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          v-model="newItem.Price"
                          class="form-control"
                          placeholder="Price"
                          type="number"
                          v-on:change="computeSalesTotal"
                        ></b-form-input>
                      </td>
                      <td v-if="globalTaxtType == 'Vatable'">
                        <b-form-select
                          v-model="newItem.TaxType"
                          :options="options.TaxType"
                          class="form-control"
                          placeholder="Type"
                          v-on:change="computeSalesTotal"
                        ></b-form-select>
                      </td>
                      <td>
                        <button
                          ref="submitItem"
                          :disabled="isBusy"
                          class="text-muted d-block"
                          type="button"
                          @click="addItem"
                        >
                          <i class="flaticon2-add-square"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <b-form-group v-if="globalTaxtType == 'Vatable'" label="Mode">
                <b-form-radio-group
                  v-model="$v.form.TaxMode.$model"
                  :options="options.TaxMode"
                  :state="validateState('TaxMode', this.$v.form)"
                  name="radio-options-TaxMode"
                  @change="computeSalesTotal"
                ></b-form-radio-group>
              </b-form-group>
              <h5>Totals</h5>
              <div v-if="globalTaxtType == 'Vatable' && form.TaxMode =='Cost Plus'">
                <b-form-group label="Gross Sales (VAT Exclusive)" label-for="GrossSales">
                  <b-form-input
                    v-model="$v.form.Totals.GrossSales.$model"
                    type="number"
                    :state="validateState('GrossSales', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="GrossSales"
                    placeholder="Gross Sales"
                    size="sm"
                    readonly
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Less: Discount"
                  label-for="TotalDeductions"
                >
                  <b-form-input
                    v-model="$v.form.Totals.TotalDeductions.$model"
                    :state="
                      validateState('TotalDeductions', this.$v.form.Totals)
                    "
                    class="form-control form-control-solid h-auto py-3 px-3 w-100"
                    name="TotalDeductions"
                    placeholder="Total Deductions"
                    size="sm"
                    v-on:change="computeTotalAmount"
                    disabled
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Deductions is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Subtotal" label-for="TotalSales">
                  <b-form-input
                    v-model="$v.form.Totals.TotalSales.$model"
                    type="number"
                    :state="validateState('TotalSales', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="TotalSales"
                    placeholder="Subtotal"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Subtotal is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group  v-if="globalTaxtType == 'Vatable'" label="Add: VAT" label-for="AddVat">
                  <b-form-input
                    v-model="$v.form.Totals.AddVat.$model"
                    type="number"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="AddVat"
                    placeholder="Add: VAT"
                    size="sm"
                    readonly
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Amount Due" label-for="TotalAmount">
                  <b-form-input
                    v-model="$v.form.Totals.TotalAmount.$model"
                    type="number"
                    :state="validateState('TotalAmount', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto py-3 px-3 w-100"
                    name="TotalAmount"
                    placeholder="Total Amount"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Amount is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div v-else>
                <b-form-group :label="(globalTaxtType == 'Vatable')? 'Subtotal (VAT inclusive)' : 'Subtotal'" label-for="TotalSales">
                  <b-form-input
                    v-model="$v.form.Totals.TotalSales.$model"
                    type="number"
                    :state="validateState('TotalSales', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="TotalSales"
                    placeholder="Subtotal"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Subtotal is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-if="globalTaxtType == 'Vatable'" label="Less: VAT" label-for="LessVat">
                  <b-form-input
                    v-model="$v.form.Totals.LessVat.$model"
                    type="number"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="LessVat"
                    placeholder="Less: VAT"
                    size="sm"
                    readonly
                  ></b-form-input>
                </b-form-group>
                <b-form-group v-if="globalTaxtType == 'Vatable'" label="Net VAT Amount" label-for="NetVat">
                  <b-form-input
                    v-model="$v.form.Totals.NetVat.$model"
                    type="number"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="NetVat"
                    placeholder="Net VAT Amount"
                    size="sm"
                    readonly
                  ></b-form-input>
                </b-form-group>
                <!--                <b-form-group label="Total Due" label-for="TotalDue">-->
                <!--                  <b-form-input v-model="$v.form.Totals.TotalDue.$model" :state="validateState('TotalDue', this.$v.form.Totals)" class="form-control form-control-solid h-auto py-3 px-3" name="TotalDue" placeholder="Total Due" size="sm"></b-form-input>-->
                <!--                  <b-form-invalid-feedback>-->
                <!--                    Total Due is required.-->
                <!--                  </b-form-invalid-feedback>-->
                <!--                </b-form-group>-->
                <b-form-group
                  label="Less: Discount"
                  label-for="TotalDeductions"
                >
                  <b-form-input
                    v-model="$v.form.Totals.TotalDeductions.$model"
                    :state="
                      validateState('TotalDeductions', this.$v.form.Totals)
                    "
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="TotalDeductions"
                    placeholder="Total Deductions"
                    size="sm"
                    v-on:change="computeTotalAmount"
                    disabled
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Deductions is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group  v-if="globalTaxtType == 'Vatable'" label="Add: VAT" label-for="AddVat">
                  <b-form-input
                    v-model="$v.form.Totals.AddVat.$model"
                    type="number"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="AddVat"
                    placeholder="Add: VAT"
                    size="sm"
                    readonly
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="Amount Due" label-for="TotalAmount">
                  <b-form-input
                    v-model="$v.form.Totals.TotalAmount.$model"
                    type="number"
                    :state="validateState('TotalAmount', this.$v.form.Totals)"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="TotalAmount"
                    placeholder="Total Amount"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Total Amount is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <div v-if="globalTaxtType == 'Vatable' && form.TaxMode == 'VAT Inclusive'">
                <h5>VAT Breakdown</h5>
                <div>
                  <b-form-group label="VATable Sales" label-for="VatableSales">
                    <b-form-input
                      v-model="$v.form.Totals.VatableSales.$model"
                      type="number"
                      class="form-control form-control-solid h-auto w-100 py-3 px-3"
                      name="VatableSales"
                      placeholder="VATable Sales"
                      size="sm"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="VAT-exempt Sales" label-for="VatExemptSales">
                    <b-form-input
                      v-model="$v.form.Totals.VatExemptSales.$model"
                      type="number"
                      class="form-control form-control-solid h-auto w-100 py-3 px-3"
                      name="VatExemptSales"
                      placeholder="VAT-exempt Sales"
                      size="sm"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Zero Rated Sales" label-for="ZeroRatedSales">
                    <b-form-input
                      v-model="$v.form.Totals.ZeroRatedSales.$model"
                      type="number"
                      class="form-control form-control-solid h-auto w-100 py-3 px-3"
                      name="ZeroRatedSales"
                      placeholder="Zero Rated Sales"
                      size="sm"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="VAT Amount" label-for="VatAmount">
                    <b-form-input
                      v-model="$v.form.Totals.VatAmount.$model"
                      type="number"
                      class="form-control form-control-solid h-auto w-100 py-3 px-3"
                      name="VatAmount"
                      placeholder="VAT Amount"
                      size="sm"
                      readonly
                    ></b-form-input>
                  </b-form-group>
                </div>
              </div>

              <!-- Withholding Tax -->
              <div v-if="globalTaxtType != 'Vatable'">
                 <b-form-group
                      label=""
                      label-for="addWithholdingTax"
                    >
                      <b-form-checkbox
                        id="addWithholdingTax"
                        v-model="form.AddWithholdingTax"
                        name="addWithholdingTax"
                      >
                        Less: Withholding Tax
                      </b-form-checkbox>
                  </b-form-group>
                  <b-form-group v-if="form.AddWithholdingTax" label="" label-for="withholdingTax">
                    <b-form-input
                      v-model="form.Totals.WithholdingTax"
                      type="number"
                      class="form-control form-control-solid h-auto w-100 py-3 px-3"
                      name="withholdingTax"
                      placeholder="Withholding Tax"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group v-if="form.AddWithholdingTax" label="Payment Due" label-for="paymentDue">
                    <b-form-input
                      v-model="form.Totals.PaymentDue"
                      type="number"
                      class="form-control form-control-solid h-auto w-100 py-3 px-3"
                      name="paymentDue"
                      placeholder="Payment Due"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
              </div>

              <h5>Payment</h5>
              <div>
                <b-form-group label="">
                  <b-form-radio-group
                    v-model="$v.form.Payment.PaymentType.$model"
                    :options="options.PaymentType"
                    :state="validateState('PaymentType', this.$v.form.Payment)"
                    name="radio-options-PaymentType"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback>
                    Payment Type is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Form of Payment">
                  <b-form-radio-group
                    v-model="$v.form.Payment.Mode.$model"
                    :options="options.FormOfPayment"
                    :state="validateState('Mode', this.$v.form.Payment)"
                    name="radio-options-FormOfPayment"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback>
                    Form Of Payment is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group v-if="form.Payment.Mode === 'e-Payment'"
                  label="Type of e-Payment">
                  <b-form-radio-group
                    v-model="$v.form.Payment.TypeOfEPayment.$model"
                    :options="options.TypeOfEPayment"
                    :state="validateState('TypeOfEPayment', this.$v.form.Payment)"
                    name="radio-options-TypeOfEPayment"
                  ></b-form-radio-group>
                  <b-form-invalid-feedback>
                    Type of e-Payment is required.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  v-if="form.Payment.Mode !== 'Cash'"
                  :label="form.Payment.Mode + ' Reference Number'"
                  label-for="ReferenceNumber"
                >
                  <b-form-input
                    v-model="$v.form.Payment.ReferenceNumber.$model"
                    :state="
                      validateState('ReferenceNumber', this.$v.form.Payment)
                    "
                    class="form-control form-control-solid h-auto py-3 px-3"
                    name="ReferenceNumber"
                    placeholder="Reference Number"
                    size="sm"
                  ></b-form-input>
                  <b-form-invalid-feedback>
                    Reference Number is required.
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>

              <h5>Remarks</h5>
              <div>
                <b-form-input
                    v-model="$v.form.Remarks.$model"
                    type="text"
                    class="form-control form-control-solid h-auto w-100 py-3 px-3"
                    name="Remarks"
                    placeholder="Remarks"
                    size="sm"
                ></b-form-input>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div class="card-footer">
          <div class="d-flex flex-wrap flex-center">
            <BackButton></BackButton>
            <button
              ref="submit"
              :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
              class="btn btn-primary mx-4"
              type="button"
              @click="submit"
            >
              Generate
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import BackButton from "@/view/content/widgets/backbutton.vue";
import ApiService from "@/view/pages/easyreceipt/api";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  mixins: [validationMixin],
  components: { BackButton },
  directives: { mask },
  props: ["propdata"],
  data() {
    return {
      isBusy: false, //isNew: false,
      form: {
        BusinessProfileId: "",
        SeriesType: "",
        Source: "",
        TransactionDateTime: moment(new Date()).format('YYYY-MM-DD'),
        Buyer: {
          Name: "",
          Address: "",
          TIN: "",
          BranchCode: "00000",
          BusinessStyle: ""
        },
        DiscountType: "None",
        Rate: 0,
        SeniorCitizen: {
          Name: "",
          TIN: "",
          OSCAIdNumber: "",
          Discounts: [
            {
              DiscountCode: "",
              Description: "",
              DiscountAmount: 0
            }
          ],
          DiscountTotal: "",
          Signature: ""
        },
        PersonWithDisability: {
          Name: "",
          TIN: "",
          PwdIdNumber: "",
          Discounts: [
            {
              DiscountCode: "",
              Description: "",
              DiscountAmount: ""
            }
          ],
          DiscountTotal: 0,
          Signature: ""
        },
        NAAC: {
          Name: "",
          IDNumber: "",
          Discounts: [
            {
              DiscountCode: "",
              DiscountAmount: ""
            }
          ],
          DiscountTotal: 0,
          Signature: ""
        },
        NatureOfService: "",
        Items: [],
        TaxMode: '',
        AddWithholdingTax: false,
        Totals: {
          //Quantity: "",
          GrossSales: 0,
          TotalSales: 0,
          TotalDeductions: 0,
          TotalAmount: 0,
          WithholdingTax: 0,
          PaymentDue: 0
        },
        Payment: {
          PaymentType: "Full payment",
          Mode: "Cash",
          TypeOfEPayment: "",
          ReferenceNumber: ""
        },
        Remarks: ""
      },
      profiles: [],
      newItem: {
        Description: "",
        Quantity: "",
        Unit: "",
        Price: "",
        TaxType: this.globalTaxtType
      },
      showSeniorDiscount: false,
      showPwdDiscount: false,
      showNaacDiscount: false,
      showStoreOtherDiscount: false,
      options: {
        PaymentType: [
          {
            text : "Full payment",
            value : "Full payment"
          },
          {
            text : "Partial payment",
            value : "Partial payment"
          }
        ],
        FormOfPayment: [
          {
            text: "e-Payment",
            value: "e-Payment"
          },
          {
            text: "Check",
            value: "Check"
          },
          {
            text: "Debit Card",
            value: "Debit"
          },
          {
            text: "Credit Card",
            value: "Credit"
          },
          {
            text: "Cash",
            value: "Cash"
          },
          {
            text: "Others",
            value: "Others"
          }
        ],
        TypeOfEPayment: [
          {
            text: "Bank transfer",
            value: "Bank transfer"
          },
          {
            text: "GCash",
            value: "GCash"
          },
          {
            text: "PayMaya",
            value: "PayMaya"
          },
          {
            text: "Other e-Wallet",
            value: "Other e-Wallet"
          },
          {
            text: "Other",
            value: "Other"
          }
        ],
        DiscountType: [
          {
            text: "None",
            value: "None"
          },
          {
            text: "Senior Citizen",
            value: "Senior Citizen"
          },
          {
            text: "PWD",
            value: "PWD"
          },
          {
            text: "NAAC",
            value: "NAAC"
          },
          {
            text: "Store/Other",
            value: "Store/Other"
          }
        ],
        Rate: [
          {
            text: "5%",
            value: 5
          },
          {
            text: "20%",
            value: 20
          }
        ],
        TaxType: [
          {
            text: "Vatable",
            value: "Vatable"
          },
          {
            text: "Non-Vatable",
            value: "Non-Vatable"
          },
          {
            text: "Zero rated",
            value: "Zero rated"
          }
        ],
        TaxMode: [
          {
            text: "VAT Inclusive",
            value: "VAT Inclusive"
          },
          {
            text: "Cost Plus",
            value: "Cost Plus"
          }
        ]
      }
    };
  },
  validations: {
    form: {
      BusinessProfileId: { required },
      TransactionDateTime: { required },
      Buyer: {
        Name: { required },
        Address: { required },
        TIN: { required },
        BranchCode: { required },
        BusinessStyle: {}
      },
      DiscountType: {required},
      Rate: { required },
      SeniorCitizen: {
        Name: {},
        TIN: {},
        OSCAIdNumber: {},
        DiscountTotal: {},
        Signature: {}
      },
      PersonWithDisability: {
        Name: {},
        TIN: {},
        PwdIdNumber: {},
        DiscountTotal: {},
        Signature: {}
      },
      NAAC: {
        Name: {},
        IDNumber: {}
      },
      NatureOfService: { required },
      Items: [],
      TaxMode: {},
      Totals: {
        GrossSales: {},
        TotalSales: { required },
        TotalDeductions: { required },
        TotalAmount: { required },
        LessVat: {},
        NetVat: {},
        AddVat: {},
        VatableSales: {},
        VatExemptSales: {},
        ZeroRatedSales: {},
        VatAmount: {}
      },
      Payment: {
        PaymentType: { required },
        Mode: { required },
        // TypeOfEPayment: { required : requiredIf(function() {
        //   return this.form.Payment.Mode === "e-Payment";
        // }) },
        TypeOfEPayment: {},
        ReferenceNumber: {}
      },
      Remarks: {}
    }
  },
  computed: {
    ...mapGetters(["currentUser", "currentUserProfile","currentUserRoles"]),
    globalTaxtType() {
      let taxType = (this.currentUserProfile && this.currentUserProfile.TaxType == "VAT")? "Vatable" : "";
      return taxType;
    }
  },
  mounted() {
    if(!this.hasRole('easyreceipt:services')) {
      this.$router.replace("/")
    }
    this.init();
  },
  watch: {
    globalTaxtType: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal != oldVal) {
          this.newItem.TaxType = newVal;
          if(newVal == 'Vatable') {
            this.form.TaxMode = 'Vat Inclusive';
          }
        }
      }
    },
    "form.SeniorCitizen.DiscountTotal": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.form.SeniorCitizen.Discounts = [];
        this.form.SeniorCitizen.Discounts.push({
          DiscountCode: "",
          Description: "",
          DiscountAmount: newValue
        });
        this.computeDiscountTotal();
      }
    },
    "form.PersonWithDisability.DiscountTotal": function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.form.PersonWithDisability.Discounts = [];
        this.form.PersonWithDisability.Discounts.push({
          DiscountCode: "",
          Description: "",
          DiscountAmount: newValue
        });
        this.computeDiscountTotal();
      }
    },
    "form.Payment.Mode" : {
      deep: true,
      handler(newValue, oldValue){
        if (newValue != "" && newValue != oldValue) {
          if(newValue == "e-Payment") {
            this.form.Payment.TypeOfEPayment = "";
          }
        }
      }
    },
    "form.DiscountType" : {
      deep: true,
      handler(newValue, oldValue){
        if (newValue != "" && newValue != oldValue) {
          if(newValue == "Senior Citizen") {
            this.showSeniorDiscount = true;
            this.showPwdDiscount = false;
            this.showNaacDiscount = false;
            this.showStoreOtherDiscount = false;
            this.form.Rate = 5;
          } else if(newValue == "PWD") {
            this.showSeniorDiscount = false;
            this.showPwdDiscount = true;
            this.showNaacDiscount = false;
            this.showStoreOtherDiscount = false;
            this.form.Rate = 5;
          } else if(newValue == "Store/Other") {
            this.showSeniorDiscount = false;
            this.showPwdDiscount = false;
            this.showNaacDiscount = false;
            this.showStoreOtherDiscount = true;
            this.form.Rate = 0;
          } else if(newValue == "NAAC") {
            this.showSeniorDiscount = false;
            this.showPwdDiscount = false;
            this.showNaacDiscount = true;
            this.showStoreOtherDiscount = false;
            this.form.Rate = 20;
          } else {
            this.showSeniorDiscount = false;
            this.showPwdDiscount = false;
            this.showNaacDiscount = false;
            this.showStoreOtherDiscount = false;
            this.form.Rate = 0;
          }
          this.computeTotalAmount();
        }
      }
    },
    "form.Rate" : {
      deep: true,
      handler(newValue, oldValue){
        if (newValue != "" && newValue != oldValue) {
          this.computeTotalAmount();
        }
      }
    },
    "form.AddWithholdingTax" : {
      deep: true,
      handler(newValue, oldValue){
        if(newValue != oldValue) {
          if(!newValue) {
            this.form.Totals.WithholdingTax = 0;
          } else {
            const amount_due = this.form.Totals.TotalAmount;
            const withholdingTax = amount_due * 0.02; //2%
            this.form.Totals.WithholdingTax = withholdingTax.toFixed(2);
          }
        }
      }
    },
    "form.Totals.WithholdingTax" : {
      deep: true,
      handler(newValue, oldValue){
        if(newValue != oldValue) {
          this.computeTotalAmount()
        }
      }
    }
  },
  methods: {
    init() {
      this.setBreadcrumbs("Create");
      this.resetForm();
      this.getProfiles();
    },
    setBreadcrumbs(value) {
      let payload = [
        {
          title: "Easy Receipt",
          route: "/easyreceipt"
        },
        {
          title: "Sales",
          route: "/easyreceipt/sales"
        }
      ];
      payload.push({ title: value });
      this.$store.dispatch(SET_BREADCRUMB, payload);
    },
    validateState(name, container) {
      if (container) {
        const { $dirty, $error } = container[name];
        return $dirty ? !$error : null;
      } else {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    hasRole: function(roleName) {
      let retVal = false;
      if (this.currentUserRoles)
        retVal = this.currentUserRoles.indexOf(roleName) !== -1;
      return retVal;
    },
    resetForm() {
      this.form = {
        BusinessProfileId: "",
        SeriesType: "Services",
        Source: "Web",
        TransactionIdentifier: "",
        TransactionDateTime: moment(new Date()).format('YYYY-MM-DD'),
        MachineIdentificationNumber: "",
        Buyer: {
          Name: "",
          Address: "",
          TIN: "",
          BranchCode: "00000",
          BusinessStyle: ""
        },
        DiscountType: "None",
        Rate: 0,
        SeniorCitizen: {
          Name: "",
          TIN: "",
          OSCAIdNumber: "",
          Discounts: [],
          DiscountTotal: 0,
          Signature: ""
        },
        PersonWithDisability: {
          Name: "",
          TIN: "",
          PwdIdNumber: "",
          Discounts: [],
          DiscountTotal: 0,
          Signature: ""
        },
        NAAC: {
          Name: "",
          IDNumber: "",
          Discounts: [],
          DiscountTotal: 0,
          Signature: ""
        },
        NatureOfService: "",
        Items: [],
        TaxMode: (this.globalTaxtType == 'Vatable')? 'VAT Inclusive' : '',
        AddWithholdingTax: false,
        Totals: {
          GrossSales: 0,
          TotalSales: 0,
          TotalDeductions: 0,
          TotalAmount: 0,
          LessVat: 0,
          NetVat: 0,
          AddVat: 0,
          VatableSales: 0,
          VatExemptSales: 0,
          ZeroRatedSales: 0,
          VatAmount: 0,
          WithholdingTax: 0,
          PaymentDue: 0
        },
        Payment: {
          PaymentType: "Full payment",
          Mode: "Cash",
          TypeOfEPayment: "",
          ReferenceNumber: ""
        },
        Remarks: ""
      };
      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    getProfiles() {
      this.isBusy = true;
      let self = this;
      return new Promise((resolve, reject) => {
        let param = {};
        ApiService.get("business/myprofiles", param)
          .then(({ data }) => {
            this.$gtag.event("business_myprofiles", param);
            self.profiles = data;
            if (data.length === 1) {
              self.form.BusinessProfileId = data[0].value;
            }
            self.isBusy = false;
            resolve(data);
          })
          .catch(({ response }) => {
            reject(response);
          });
      });
    },

    submit: function(e) {
      e.preventDefault();
      this.autoAddItem();
      if (this.form.Items.length === 0) return;
      this.postCreate();
    },
    postCreate() {
      let self = this;
      self.isBusy = true;
      let param = self.form;
      const submitButton = self.$refs["submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      ApiService.put("sales/create", param)
        .then(({ data }) => {
          this.$gtag.event("sales_create", param);
          if (data) {
            self.isBusy = false;
            submitButton.classList.remove(
              "spinner",
              "spinner-light",
              "spinner-right"
            );
            this.$router.push({ name: "easyreceipt-sales-list" });
          }
        })
        .catch(() => {
          self.isBusy = false;
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    addItem() {
      console.log(this.form.Items);
      this.form.Items.push(this.newItem);
      this.newItem = {
        Description: "",
        Quantity: "",
        Unit: "",
        Price: "",
        TaxType: this.globalTaxtType
      };
      console.log(this.form.Items);
    },
    autoAddItem() {
      if (
        this.newItem.Description !== "" &&
        this.newItem.Quantity !== "" &&
        this.newItem.Unit !== "" &&
        this.newItem.Price !== ""
      )
        this.addItem();
    },
    confirmDeleteItem(item) {
      let self = this;
      Swal.fire({
        //title: 'Are you sure?',
        html: "Are you sure you want to delete this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.isConfirmed) {
          let array = self.form.Items;
          const index = array.indexOf(item);
          if (index > -1) {
            array.splice(index, 1);
          }
          this.computeSalesTotal();
        }
      });
    },
    addSeniorCitizenDiscount() {
      this.showSeniorDiscount = !this.showSeniorDiscount;
    },
    addPwdDiscount() {
      this.showPwdDiscount = !this.showPwdDiscount;
    },
    computeSalesTotal() {
      let newTotal = 0;
      let vatableSales = 0;
      let vatExemptSales = 0;
      let zeroRatedSales = 0;
      for (let i = 0; i < this.form.Items.length; i++) {
        let priceNum = Number(this.form.Items[i].Price);
        let qty = Number(this.form.Items[i].Quantity);
        let type = this.form.Items[i].TaxType;
        if (!isNaN(priceNum) && !isNaN(qty)) {
          let subTotal = qty * priceNum;
          newTotal += subTotal;
          if(type == 'Vatable') {
            vatableSales += subTotal;
          } else if(type == 'Non-Vatable') {
            vatExemptSales += subTotal;
          } else if(type == 'Zero rated') {
            zeroRatedSales += subTotal;
          }
        }
      }
      let priceNumNew = Number(this.newItem.Price);
      let qtyNumNew = Number(this.newItem.Quantity);
      if (!isNaN(priceNumNew) && !isNaN(qtyNumNew)) {
        let type = this.newItem.TaxType;
        let subTotal = qtyNumNew * priceNumNew;
        newTotal += subTotal;
        if(type == 'Vatable') {
          vatableSales += subTotal;
        } else if(type == 'Non-Vatable') {
          vatExemptSales += subTotal;
        } else if(type == 'Zero rated') {
          zeroRatedSales += subTotal;
        }
      }
      this.form.Totals.TotalSales = newTotal.toFixed(2);
      this.form.Totals.GrossSales = newTotal.toFixed(2);
      //VAT
      if(this.globalTaxtType == 'Vatable' && this.form.TaxMode == 'VAT Inclusive') {
        vatableSales = (vatableSales > 0)? (vatableSales / 1.12) : 0;
        this.form.Totals.VatableSales = vatableSales.toFixed(2);
        this.form.Totals.VatExemptSales = vatExemptSales.toFixed(2);
        this.form.Totals.ZeroRatedSales = zeroRatedSales.toFixed(2);
        let netVatAmount = vatableSales + vatExemptSales + zeroRatedSales;
        let vatAmount = vatableSales * 0.12;
        this.form.Totals.NetVat = netVatAmount.toFixed(2);
        this.form.Totals.LessVat = vatAmount.toFixed(2);
        this.form.Totals.AddVat = vatAmount.toFixed(2);
        this.form.Totals.VatAmount = vatAmount.toFixed(2);
      } else {
        this.form.Totals.NetVat = 0;
        this.form.Totals.LessVat = 0;
        this.form.Totals.AddVat = 0;
        this.form.Totals.VatAmount = 0;
      }
      //Total Amount
      this.computeTotalAmount();
    },
    computeDiscountTotal() {
      let totalSales = 0;
      if(this.globalTaxtType == 'Vatable' && this.form.TaxMode == 'Cost Plus') {
        if (!isNaN(Number(this.form.Totals.GrossSales)))
          totalSales = Number(this.form.Totals.GrossSales);
      } else if(this.globalTaxtType == 'Vatable') {
        if (!isNaN(Number(this.form.Totals.NetVat)))
          totalSales = Number(this.form.Totals.NetVat);
      } else {
        if (!isNaN(Number(this.form.Totals.TotalSales)))
          totalSales = Number(this.form.Totals.TotalSales);
      }
      const rate = this.form.Rate;
      var total = (rate / 100) * totalSales;
      if(!isNaN(Number(total)))
        this.form.Totals.TotalDeductions = total.toFixed(2);
    },
    computeTotalAmount() {
      this.computeDiscountTotal();
      let totalSales = 0;
      let totalDeductions = 0;
      if(this.globalTaxtType == 'Vatable' && this.form.TaxMode == 'Cost Plus') {
        if (!isNaN(Number(this.form.Totals.GrossSales)))
          totalSales = Number(this.form.Totals.GrossSales);
        if (!isNaN(Number(this.form.Totals.TotalDeductions)))
          totalDeductions = Number(this.form.Totals.TotalDeductions);
        let actual_total_sales = totalSales - totalDeductions;
        let addVat = actual_total_sales * 0.12;
        let amount_due = actual_total_sales + addVat;
        this.form.Totals.TotalSales = actual_total_sales.toFixed(2);
        this.form.Totals.AddVat = addVat.toFixed(2);
        this.form.Totals.TotalAmount = amount_due.toFixed(2);
      } else {
        if (!isNaN(Number(this.form.Totals.TotalSales)))
          totalSales = Number(this.form.Totals.TotalSales);
        if (!isNaN(Number(this.form.Totals.TotalDeductions)))
          totalDeductions = Number(this.form.Totals.TotalDeductions);
        let amount_due = totalSales - totalDeductions;
        this.form.Totals.TotalAmount = amount_due.toFixed(2);
      }

      //Compute Withholding Tax
      if(this.globalTaxtType != 'Vatable' && this.form.AddWithholdingTax) {
        const paymentDue = this.form.Totals.TotalAmount - this.form.Totals.WithholdingTax;
        this.form.Totals.PaymentDue = paymentDue.toFixed(2)
      } else {
        this.form.Totals.PaymentDue = this.form.Totals.TotalAmount;
      }
    }
  }
};
</script>
